module.exports = __webpack_public_path__ + "gfx/UT-15SL-01.png";